import React from 'react'

import { WEBSITE_LD } from 'helpers/SEOHelper'

const WebSiteLD = () => {
  // eslint-disable-next-line react/no-danger
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: WEBSITE_LD }} />
}

export default WebSiteLD
